import axios from "axios";
import { BASE_URL } from "baseConfig";





export const RegisterData = async (values) => {

  try {

    const res = await axios.post(`${BASE_URL}/v1/users/register`, values, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = res.data;
    return data

  } catch (error) {

    console.error('Failed to create account:', error);

  }
}


export const SignInData = async (values) => {

  const res = await axios.post(`${BASE_URL}/v1/users/login`, values, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const data = res.data;

  if (!data || !data.token) {
    throw new Error('Invalid response from server');
  }

  localStorage.setItem('token', data.token);
  localStorage.setItem('user', JSON.stringify(data))

  return data

}


export const updateData = async (values, token) => {

  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user[0] || !user[0].id) {
      throw new Error('User not found in localStorage');
    }

    const res = await axios.put(`${BASE_URL}/v1/users/users/${user[0].id}`, values, {
      headers: {
        'authorization': token,
        'Content-Type': 'application/json',
      },
    });

    const data = await res.data;
   
    return data;
  } catch (error) {
    console.error('Failed to update profile:', error);
    throw error;
  }
}